import {setFixedStringAt} from 'util/StringUtil';
import React from 'react';

export const evoAppsUserToSerialID = function (user, defaultUser) {
	const isDefault = user.username === defaultUser.username && user.userGroup.id === defaultUser.userGroup.id;
	let id = setFixedStringAt("", user.username, 0, 8);
	id = setFixedStringAt(id, user.userGroup.id, 8, 8);
	id = setFixedStringAt(id, isDefault ? 1 : 0, 16, 1);
	return id;
};

export const parseEvoAppsUserSerialID = serialid => ({
	username: serialid.substr(0, 8).trim(),
	userGroup: serialid.substr(8, 8).trim(),
	reset: serialid.substr(16, 1).trim() === '1',
});

export const filterOptions = (option, inputValue) => {
	const {label, value} = option;
	const search = inputValue && inputValue.toLowerCase() || "";
	const _value = value && value.toLowerCase() || "";
	if (typeof label !== 'string') {
		const {
			props: {
				user: {
					text,
					longUsername,
					userGroup: {
						id, description,
					},
				},
			},
		} = label;
		const _label = [longUsername, text, id, description].join(" ").toLowerCase();
		return _value.includes(search) || _label.includes(search);
	}
	return _value.includes(search) || label.includes(search);
};